import React, { useCallback } from 'react'
import { cleanPhone } from 'utils/cleanPhone'
import { formatPhoneOnPaste } from 'utils/formatPhone'
import { focusMaskStart, phoneInputMask } from 'utils/masks'

/** Props for a masked phone ShadowInput: paste in any format, clear a lone «+7» on blur */
export const usePhoneField = (value: string, setValue: (value: string) => void) => {
  const onBlur = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    if (cleanPhone(e.target.value) === '7') {
      setValue('')
    }
  }, [setValue])
  const onPaste = useCallback((e: React.ClipboardEvent) => setValue(formatPhoneOnPaste(e)), [setValue])
  return {
    type: 'tel',
    value,
    onChange: setValue,
    onFocus: focusMaskStart,
    onBlur,
    onPaste,
    mask: phoneInputMask,
  }
}
